import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=b456bc44&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b456bc44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b456bc44')) {
      api.createRecord('b456bc44', component.options)
    } else {
      api.reload('b456bc44', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=b456bc44&scoped=true&", function () {
      api.rerender('b456bc44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cOHALZWSULwj/JS/comp/Accordion.vue"
export default component.exports